import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import InfoPopover from 'components/common/InfoPopover';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import makeStyles from '@mui/styles/makeStyles';
import {
  FONT_GSS_FUTURA_BOOK,
  FONT_GSS_FUTURA_SEMI_BOLD,
  baseTheme,
} from '@monorepo/shared/src/themes/defaultTheme';

const ProgressCard: React.FC<any> = ({
  title,
  highlightedText,
  label,
  helpText,
  noOutline,
  disabled,
  ...rest
}) => {
  const classes = useStyles({ disabled });
  return (
    <Paper variant={!noOutline ? 'outlined' : ''} elevation={0} className={classes.root} {...rest}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography className={classes.title}>{title}</Typography>
        {helpText && (
          <InfoPopover>
            <Typography className={classes.helpText}>{helpText}</Typography>
          </InfoPopover>
        )}
      </Box>
      <Box display="flex" gap={remCalc(8)} alignItems="baseline">
        <Typography className={classes.highlightedText}>{highlightedText}</Typography>
        <Typography className={classes.label}>{label}</Typography>
      </Box>
    </Paper>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    padding: `${remCalc(12)} ${remCalc(14)} ${remCalc(12)} ${remCalc(24)}`,
    flex: 1,
    color: (props: { disabled: boolean }) =>
      props.disabled ? baseTheme.palette.grey[400] : baseTheme.palette.common.black,
  },
  title: {
    fontSize: remCalc(18),
    lineHeight: remCalc(28),
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
  },
  highlightedText: {
    fontSize: remCalc(28),
    lineHeight: remCalc(42),
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
  },
  label: {
    fontSize: remCalc(18),
    lineHeight: remCalc(18),
    fontFamily: FONT_GSS_FUTURA_BOOK,
  },
  helpText: {
    fontSize: remCalc(14),
    lineHeight: remCalc(18),
    fontFamily: FONT_GSS_FUTURA_BOOK,
  },
}));

export default ProgressCard;
